import React from "react";
import { usePerformanceDetailsForPreview } from "@/api/hooks/usePerformanceDetailsForPreview";

const ArtistPremiumPerformance = () => {
  const {
    performingCount,
    offstageCount,
    durationText,
    openToTravel,
    languages,
  } = usePerformanceDetailsForPreview();

  return (
    <div className="md:mb-24 px-5 md:px-10 lg:px-20 w-screen">
      <h3 className="text-[28px] text-center md:text-[42px] font-bold bg-gradient-to-r from-[#F16B2E] via-[#EC2179] to-[#EC2179] text-transparent bg-clip-text mt-16">
        PERFORMANCE DETAILS
      </h3>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-6  mt-8 mb-20 border border-zinc-800 rounded-3xl p-4  ">
        <div className="flex flex-col items-center justify-center text-center">
          <p className="text-2xl md:text-4xl font-bold">{performingCount}</p>
          <p className="text-sm sm:text-xl font-normal max-w-40 opacity-60">
            Performing Members
          </p>
        </div>

        <div className="flex flex-col items-center justify-center text-center">
          <p className="text-2xl md:text-4xl font-bold">{durationText}<span className="font-light"> mins</span></p>
          <p className="text-sm sm:text-xl font-normal max-w-40 opacity-60">
            Performing Duration
          </p>
        </div>
        <div className="flex flex-col items-center justify-center text-center">
          <p className="text-2xl md:text-4xl font-bold capitalize">{openToTravel}</p>
          <p className="text-sm sm:text-xl font-normal max-w-40 opacity-60">
            Open To Travel
          </p>
        </div>
        <div className="flex flex-col items-center justify-center text-center">
          <p className="text-2xl md:text-4xl font-bold">{offstageCount}</p>
          <p className="text-sm sm:text-xl font-normal max-w-40 opacity-60">
            Offstage Members
          </p>
        </div>

        <div className="flex flex-col items-center justify-center text-center max-sm:col-span-2">
          <div className="flex flex-wrap justify-center gap-1 text-xs sm:text-base font-bold">
            {languages.map((lang) => (
              <p
                key={lang.l_slug}
                className="uppercase bg-white text-black px-2 py-1 rounded-lg"
              >
                {lang.code}
              </p>
            ))}
          </div>
          <p className="text-sm sm:text-xl font-normal max-w-40 mt-2">
            Performing Languages
          </p>
        </div>
      </div>


    </div>
  );
};

export default ArtistPremiumPerformance;
